import React from 'react';
import PropTypes from 'prop-types';
import { withSignoutRedirect } from '@twigeducation/oidc-client-react';
import { logoutChannel } from './Authentication/userManager';

const LogoutButton = ({ onLogout }) => (
    <button onClick={onLogout} type="button">
        Logout
    </button>
);

LogoutButton.propTypes = {
    onLogout: PropTypes.func.isRequired,
};

export default withSignoutRedirect(() => {
    const postLogoutRedirect = sessionStorage.getItem('postLogoutRedirect');
    if (logoutChannel) {
        logoutChannel.postMessage({ type: 'logout', postLogoutRedirect });
    }
})(LogoutButton);
